import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import * as fromActions from '../../../actions/blocks.action'
import { editMultimediaBlock } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}
async function editMultimedia(blockId: number, blockDetails: any) {
  return editMultimediaBlock(blockId, blockDetails)
}

function* editMultimediaBlockEffectSaga(action: any) {
  try {
    const {
      payload: {
        id,
        lessonId,
        description,
        name,
        showTitle,
        file,
        lockProgress,
        denyDownload,
      },
    } = action

    const blockDetails = {
      block_multimedia: {
        show_title: showTitle,
        lock_progress: lockProgress,
        file: null,
        deny_download: denyDownload,
      },
      block_instance: {
        name,
        description,
        lesson_id: lessonId,
      },
    }
    if (file.id) {
      // @ts-ignore
      blockDetails.block_multimedia.file = file
    }
    yield call(editMultimedia, id, blockDetails)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editMultimediaBlockWatcherSaga() {
  yield takeLatest(
    fromActions.EDIT_MULTIMEDIA_BLOCK,
    editMultimediaBlockEffectSaga
  )
}
